<template>
    <div v-if = "!isLoading">
        <portal target-el="#filter">
            <div class="sub-header">
                <div class="header-item">
                    <Breadcrumb type="flex" separator-class="el-icon-arrow-right">
                        <breadcrumb-item
                        :to="routeToIndent"
                        >{{ $t('INDENT_OUTBOUND') }}</breadcrumb-item>
                        <breadcrumb-item>{{ $t('FREIGHT_APPROVAL') }}</breadcrumb-item>
                        <breadcrumb-item>{{ this.indentDetails.order_number }} </breadcrumb-item>
                    </Breadcrumb>
                </div>
                <div class="header-item f-right pr-10">
                    <Popover
                    v-model:visible="isPopoverVisible"
                    placement="bottom-end"
                    width="400"
                    :visible-arrow="false"
                    popper-class="popover-dark mt-m25 px-20 pb-20">

                    <div class="popover-wrapper mb-10">
                        <h4 class="text-brand text-md pt-10">{{ $t('MDM_REJECT_REASON')}}</h4>
                        <div class="text-grey-dark text-sm mb-15">{{ $t('SELECT_FREIGHT_RATE_REASON') }}</div>
                        <div class="mb-15">
                            <Form :inline="true" class="form-default">
                                <FormItem label="Select Reason" class="mb-0" required>
                                    <Select v-model="value" placeholder="Select" size="mini" class="select-default">
                                    <Option
                                        v-for="item in freightAmountReasons"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </Option>
                                    </Select>
                                </FormItem>
                            </Form>
                            <div v-if="value === 'Others'" class="mb-10 transparent-textarea">
                                <div for="comment" class="text-grey1 p-10 pb-0 text-sm required">{{ $t('Comments') }}</div>
                                <textarea v-model="comment" id="comment" rows="2" placeholder="Enter your comment..."></textarea>
                            </div>
                        </div>
                        <div class="f-right">
                            <Button type="secondary" size="mini" @click="closePopover">{{ $t('CANCEL') }}</Button>
                            <Button type="primary" size="mini" @click = "rejectFreight">{{ $t('REJECT') }}</Button>
                        </div>
                    </div>
                    <span slot="reference">
                        <Button type="secondary" size="small" class="text-red mr-10">{{ $t('REJECT') }}</Button>
                    </span>
                    </Popover>
                    <Button type="primary" size="small" @click = "approveFreight">{{ $t('APPROVE') }}</Button>
                </div>
            </div>
        </portal>

        <div class="bg-white p-15 mb-10 mt-m10">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                    <h4 class="text-sm text-blue-dark1 m-0">{{ $t("ADMIN_APPROVAL_DETAILS") }}</h4>
                </div>
            </div>

            <Row :gutter="10" type="flex" class="py-15">
                <Col :span="6">
                    <Form :inline="true" class="form-default form-multi">
                      <FormItem :label="$t('INDENT_FREIGHT_AMOUNT')" class="mb-0" disabled>
                        <Input placeholder="Please input" size="mini" v-model="selectedFreight.amount"></Input>
                    </FormItem>
                    <FormItem :label="$t('INDENT_FREIGHT_TYPE')" class="mb-0" disabled>
                      <Input placeholder="Please input" size="mini" v-model="selectedFreight.unit"></Input>
                    </FormItem>
                    </Form>
                </Col>
            </Row>

            <div>
              <label class="text-grey-dark text-xs text-normal my-5 text-capitalize">{{ $t("INDENT_ATTACHMENT") }} </label>
              <Attachments
               class="mx-m15 mt-5"
               :disableUpload="false"
               :attachments="getFreightAttachments"
               :showPreview="true"
               :disableDelete="true"
               @addAttachments="addAttachments"> </Attachments>
            </div>
            <h4 class="text-sm text-blue-dark1 mt-15">Indent Details</h4>
            <div class="flex-container panel-head align-top mt-m10">
            <div class="flex-item">
                <p>
                  {{$t('INDENT_VEHICLE_REQUIREMENT_DATE')}}:
                    <strong class="text-bold">{{$moment(this.indentDetails.sources[0].loading_date).format("DD-MM-YYYY | hh:mm A")}}</strong>
                </p>
                <p>
                  {{$t('INDENT_SHIPPED_FROM')}}
                    <strong class="text-bold">{{ this.indentData.source }}</strong>
                </p>
                <p>
                  {{$t('INDENT_SHIPPED_TO')}}
                    <strong class="text-bold">{{ this.indentData.destination }}</strong>
                </p>
            </div>
            <div class="flex-item">
                <p>
                  {{$t('INDENT_VEHICLE')}}
                    <strong class="text-bold">{{ this.indentData.vehicle }}</strong>
                </p>
                <p>
                  {{$t('INDENT_DELIVERY_TYPE')}}:
                    <strong class="text-bold">{{ this.indentData.deliveryType }}</strong>
                </p>
                <p>
                   {{$t('INDENT_BASE_FREIGHT')}}:
                    <strong class="text-bold text-green">INR {{ this.indentData.baseFreight}}</strong>
                </p>
            </div>
            </div>
        </div>
    </div>
  </template>

<script>
import { movementType } from 'pando-constants';
import contractConstants from '@/constants/contract';
import { freightAmountReasons } from '@/constants/reason-settings';

import Attachments from '@common/components/Attachments';

export default {
  components: {
    Attachments,
  },
  data() {
    return {
      isPopoverVisible: false,
      comment: '',
      value: '',
      isLoading: false,
      indentDetails: {},
      remarks: '',
      freightAmountReasons,
      selectedFreight: {
        amount: null,
        unit: null,
        attachment_ids: [],
        isShipperApproval: false,
        userRejected: false,
        sendForApproval: true,
      },
      indentData: {
        source: '',
        destination: '',
        vehicle: '',
        deliveryType: '',
        baseFreight: '',
      },
    };
  },
  computed: {
    getFreightAttachments() {
      return this.selectedFreight.attachment_ids;
    },
    routeToIndent() {
      return '/indents/outbound';
    },
  },
  methods: {
    togglePopover() {
      this.isPopoverVisible = !this.isPopoverVisible;
    },
    closePopover() {
      this.isPopoverVisible = false;
      this.freightAmountReasons = [];
    },
    createData(indentDetails) {
      this.selectedFreight.amount = indentDetails.base_frieght.base_freight;
      this.selectedFreight.attachment_ids = [];
      this.selectedFreight.unit = contractConstants.freightUnit[indentDetails.base_frieght.freight_unit];
      this.indentData.source = indentDetails.sources[0].details.name;
      this.indentData.destination = indentDetails.destinations[0].details.name;
      this.indentData.vehicle = indentDetails.vehicle_type.name;
      this.indentData.deliveryType = indentDetails.vehicle_type.type;
      this.indentData.baseFreight = indentDetails.base_frieght.base_freight;
    },
    async getReasonSettings() {
      let depotId;
      if (this.indentDetails && [movementType.PRIMARY, movementType.SECONDARY].includes(this.indentDetails.movement)) {
        depotId = this.indentDetails.sources && this.indentDetails.sources[0]
          && this.indentDetails.sources[0].location_id;
      } else {
        depotId = this.indentDetails.destinations && this.indentDetails.destinations[0]
          && this.indentDetails.destinations[0].location_id;
      }
      const payload = {
        type: 'INDENT_FREIGHT_AMOUNT',
        movement: this.indentDetails && this.indentDetails.movement,
        depot_id: depotId,
      };
      const result = await this.$store.dispatch('settings/getReasonSettings', payload);
      if (result && result.data && result.data.length) {
        const configReasons = result.data.map(item => ({
          key: item,
          value: item,
        }));
        this.freightAmountReasons = [
          ...this.freightAmountReasons,
          ...configReasons,
        ];
      } else {
        this.freightAmountReasons = [
          ...this.freightAmountReasons,
        ];
      }
      if (!this.freightAmountReasons.find(item => item.key === 'OTHERS')) {
        this.freightAmountReasons.push({
          value: 'Others',
          key: 'OTHERS',
        });
      }
    },
    async updateFreight() {
      try {
        const freightReason = null;
        const payload = {
          freight_amount: this.selectedFreight.amount,
          freight_unit: this.indentDetails.base_frieght.freight_unit,
          reason: freightReason,
          retriggerPayment: false,
          attachment_ids:
              this.selectedFreight.attachment_ids &&
              this.selectedFreight.attachment_ids.length
                ? this.selectedFreight.attachment_ids.map(attach => attach.id)
                : [],
          sendForApproval: this.selectedFreight.sendForApproval,
          isShipperApproval: this.selectedFreight.isShipperApproval,
          userRejected: this.selectedFreight.userRejected,
          rejection_remarks: this.comment || this.value,
        };
        if (this.selectedFreight.userRejected) {
          if (!this.value.trim()) {
            this.$errorMessage({ message: 'Enter Rejection Reason' });
            return;
          }
        }
        const result = await this.$store.dispatch('order/freightRateUpdate', {
          orderNo: this.indentDetails.order_number,
          data: payload,
        });
        if (result.id) {
          if (this.selectedFreight.userRejected) {
            this.$error({ message: result.resMessage });
          } else {
            this.$success({
              message: result.resMessage ||
                  this.$getSuccess('UPDATED_FREIGHT', {
                    firstArgument: this.order.order_number,
                  }),
            });
            this.$router.push({ path: '/indents/outbound' });
          }
        }
        if (result.error) {
          this.$error({
            message: result.error,
          });
        }
      } catch (error) {
        console.log('file: freight-approval.vue:344 ~ updateFreight ~ error', error);
        this.$error({ message: this.$getErr('APP_CATCH_ERR') });
      }
    },
    async approveFreight() {
      this.selectedFreight.isShipperApproval = true;
      this.selectedFreight.sendForApproval = false;
      await this.updateFreight();
    },
    async rejectFreight() {
      this.selectedFreight.userRejected = true;
      this.selectedFreight.sendForApproval = false;
      await this.updateFreight();
      this.closePopover();
    },
    async addAttachments(file) {
      try {
        const formData = new FormData();
        formData.append('attachment', file.raw);

        const result = await this.$store.dispatch('order/addAttachment', formData);
        if (result.error) {
          this.$error({ message: this.$t('INDENT_UPLOAD_FAILED') });
          return;
        }

        this.selectedFreight.attachment_ids.push({
          id: result.id,
          url: result.attachment_url,
        });
      } catch (err) {
        this.$error({ message: this.$getErr('APP_CATCH_ERR') });
      }
    },


    async fetchData() {
      try {
        this.isLoading = true;
        const indentDetails = await this.$store.dispatch('order/find', this.$route.params.orderId);
        this.indentDetails = indentDetails;
        this.createData(indentDetails);
        this.isLoading = false;
      } catch (error) {
        throw (error);
      }
    },
  },
  async created() {
    await this.fetchData();
    await this.getReasonSettings();
  },
};
</script>
